import { makeStyles, withStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
import { TableContainer } from '@material-ui/core';
const {
	HOVER_GRAY_SHADE,
	BLACK,
	FONT_COLOR_SECONDARY,
	FONT_COLOR,
	PURPLE,
	LIGHT_GREY,
	TOGGLE_ACTIVE,
	LIGHT_GRAY_SHADE,
	WHITE,
	GREY
} = colors;
import { Bogle_Medium, Bogle_Regular } from 'constants/constant';

const welcomeStyles = makeStyles(() => ({
	containerHeight: {
		// height: '100vh'
	},
	wrapper: {
		marginTop: '112px',
		width: '100%'
	},
	timeRefresh: {
		height: '48px',
		display: 'flex',
		borderBottom: `1px solid ${LIGHT_GREY}`,
		paddingLeft: '24px',
		alignItems: 'center',
		marginTop: '64px',
		marginBottom: '-64px',
		width: '100%'
	},
	tableHeader: {
		background: HOVER_GRAY_SHADE,
		paddingLeft: '16px',
		fontFamily: Bogle_Regular,
		fontSize: '14px'
	},
	tableFirstHeader: {
		background: HOVER_GRAY_SHADE,
		width: '8px',
		paddingLeft: '16px',
		fontFamily: Bogle_Regular,
		fontSize: '14px'
	},
	tableCell: {
		width: 'auto',
		paddingLeft: '16px',
		fontFamily: Bogle_Medium,
		fontSize: '14px',
		color: FONT_COLOR_SECONDARY
	},
	tableFirstCol: {
		background: HOVER_GRAY_SHADE,
		width: '8px',
		paddingLeft: '16px',
		fontFamily: Bogle_Medium,
		fontSize: '14px',
		color: FONT_COLOR_SECONDARY
	},
	msgContainer: {
		position: 'fixed',
		top: '50vh',
		textAlign: 'center'
	},
	msgWithImageContainer: {
		top: '50vh',
		width: '100%'
	},
	loaderContainer: {
		height: 'calc(100vh - 104px)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		paddingTop: '64px'
	},
	previewMsg: {
		fontFamily: 'Bogle-Regular',
		fontSize: '22px',
		color: BLACK,
		['@media only screen and (max-width:1024px)']: {
			fontSize: '16px'
		}
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	icon: {
		color: HOVER_GRAY_SHADE
	},
	showIcon: {
		color: FONT_COLOR
	},
	highlightFilter: {
		background: '#DADCE0',
		borderRadius: 4
	},
	iconButton: {
		marginRight: 8,
		'&:hover': {
			background: 'unset'
		}
	},
	errorContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100vw',
		height: '100vh'
	},
	fixedHeader: {
		top: 64,
		position: 'sticky'
	},
	tableContainer: {
		width: '100vw',
		overflowX: 'auto !important'
	},
	// alertWrapper: {
	// 	// width: 'calc(100% - 360px)',
	// 	position: 'relative',
	// 	zIndex: 999,
	// 	borderTop: border,
	// 	borderBottom: border,
	// 	fontSize: '14px',
	// 	width: '100%'
	// },
	msgIcon: {
		display: 'flex',
		alignItems: 'center',
		cursor: 'pointer',
		marginRight: '8px'
	},
	msgIconNonCloseable: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		cursor: 'pointer',
		marginRight: '8px',
		color: GREY,
		fontSize: '12px'
	},
	msgBox: {
		height: 'fit-content',
		display: 'flex',
		alignItems: 'center',
		color: '#3C228A',
		padding: '0 18px',
		justifyContent: 'space-between',
		borderTop: '1px solid #DADCE0',
		borderBottom: '1px solid #DADCE0',
		fontFamily: Bogle_Regular
	},
	faqLink: {
		display: 'inline-block',
		padding: '0 4px'
	},
	bulletText: {
		textAlign: 'center !important',
		justifyContent: 'center !important',
		'&.MuiListItem-root': {
			paddingTop: '4px',
			paddingBottom: '4px'
		}
	},
	bulletTextHeader: {
		textAlign: 'center !important',
		justifyContent: 'center !important',
		fontWeight: '600',
		'&.MuiListItem-root': {
			paddingBottom: '20px'
		}
	},
	highlightedFont: {
		color: PURPLE,
		fontFamily: 'Bogle-Medium'
	},
	linkItemsBtnContainer: {
		height: '48px',
		display: 'flex',
		borderBottom: `1px solid ${LIGHT_GREY}`,
		paddingLeft: '24px',
		paddingRight: '24px',
		alignItems: 'center',
		marginTop: '64px',
		marginBottom: '-64px',
		width: '98%',
		justifyContent: 'space-between',
		position: 'fixed'
	},
	linkItemsBtn: {
		textTransform: 'none',
		height: '32px',
		paddingLeft: '15px',
		marginRight: '10px',
		'&:hover': {
			background: TOGGLE_ACTIVE,
			borderRadius: '20px'
		},
		'& .userCount': {
			background: PURPLE,
			borderRadius: '50%',
			width: 'auto',
			padding: '0px 3px',
			fontSize: '10px',
			textAlign: 'center',
			alignItems: 'center',
			display: 'flex',
			height: '14px',
			marginLeft: '4px',
			color: WHITE
		}
	},
	linkItemsBtnActive: {
		background: TOGGLE_ACTIVE,
		borderRadius: '20px !important',
		paddingLeft: '15px',
		marginRight: '10px',
		height: '32px',
		'&:hover': {
			background: TOGGLE_ACTIVE,
			borderRadius: '20px'
		},
		'& .userCount': {
			background: PURPLE,
			borderRadius: '50%',
			width: 'auto',
			padding: '0px 3px',
			fontSize: '10px',
			textAlign: 'center',
			alignItems: 'center',
			display: 'flex',
			height: '14px',
			marginLeft: '4px',
			color: WHITE
		}
	},
	linkItemsBtnActiveWithBorder: {
		background: TOGGLE_ACTIVE,
		borderRadius: '20px !important',
		paddingLeft: '15px !important',
		marginRight: '10px',
		height: '32px',
		border: `1.5px solid ${PURPLE}`,
		'&:hover': {
			background: TOGGLE_ACTIVE,
			borderRadius: '20px'
		},
		'& .userCount': {
			background: PURPLE,
			borderRadius: '50%',
			width: 'auto',
			padding: '0px 3px',
			fontSize: '10px',
			textAlign: 'center',
			alignItems: 'center',
			display: 'flex',
			height: '14px',
			marginLeft: '4px',
			color: WHITE
		}
	},
	drawer: {
		width: '360px',
		flexShrink: 0,
		'& .MuiDrawer-paperAnchorDockedRight': {
			border: `1px solid ${LIGHT_GREY}`,
			borderLeftWidth: 0,
			top: '112px'
		}
	},
	drawerContainer: {
		height: '90vh',
		minWidth: 360
	},
	dataRefresh: {
		textTransform: 'none',
		marginRight: '8px',
		padding: '0 8px',
		fontSize: '14px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		fontFamily: Bogle_Regular,
		height: '32px',
		background: LIGHT_GRAY_SHADE,
		borderRadius: '20px',
		color: BLACK
	},
	customTootipCss: {
		fontSize: 12,
		width: 208,
		fontWeight: 400,
		fontFamily: Bogle_Regular
	},
	previewBox: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: 24,
		color: '#6D6E71',
		backgroundColor: '#F9F9F9'
	},
	headerText: {
		maxWidth: '325px',
		overflowX: 'auto',
		height: '60%',
		marginTop: '12px'
	},
	scrollHeader: {
		maxWidth: '325px',
		height: '60%',
		marginTop: '12px',
		'&:hover': {
			overflowX: 'auto'
		}
	},
	tooltip: {
		maxWidth: 234,
		padding: 16,
		fontFamily: Bogle_Medium,
		color: WHITE,
		fontSize: '14px'
	},
	dragger: {
		width: '1px',
		cursor: 'ew-resize',
		padding: '2px 0 0',
		borderTop: '1px solid #ddd',
		position: 'fixed',
		top: 113,
		// right: 345,
		bottom: 0,
		zIndex: 100,
		backgroundColor: '#DADCE0',
		'&:hover': {
			backgroundColor: PURPLE,
			width: 2
		}
	},
	filterTooltipContainer: {
		display: 'flex',
		width: '264px',
		padding: '12px 8px'
	},
	filterTooltip: {
		background: WHITE,
		color: BLACK,
		marginTop: '4px',
		boxShadow: '0px 5px 10px 3px rgba(0, 0, 0, 0.15), 0px -1px 4px 0px rgba(0, 0, 0, 0.10)',
		pointerEvents: 'auto'
	},
	filterTooltipArrow: {
		color: WHITE,
		filter: 'drop-shadow(0px 6px 6px rgba(0, 0, 0, 0.15))'
	},
	filterTooltipCloseBtn: {
		height: '25px',
		display: 'flex',
		alignItems: 'flex-start',
		paddingTop: '4px'
	}
}));

export const StyledTableContainer = withStyles(() => ({
	root: {
		overflowX: 'initial'
	}
}))(TableContainer);

export default welcomeStyles;
